import { render, staticRenderFns } from "./VSNGenerator.vue?vue&type=template&id=db9a8eb2"
import script from "./VSNGenerator.vue?vue&type=script&lang=ts"
export * from "./VSNGenerator.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports